module.exports = __webpack_public_path__ + "img/cross.fb87eacf.svg";